import { Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useRemoveAdmin } from '../../../hooks/api/use-remove-admin';

interface Props extends DialogActions {
  adminToken: string;
  adminEmail: string;
}

const RemoveAdminDialog: FC<Props> = ({
  open,
  onCancel,
  adminToken,
  adminEmail,
}) => {
  const { t } = useTranslation(['organizationDetails', 'common']);

  const { mutateAsync: removeAdmin, isPending: isLoadingRemoveAdmin } =
    useRemoveAdmin(onCancel);

  return (
    <Dialog
      title={t('organizationDetails:admins.deleteAdminDialog.title')}
      open={open}
      variant="warning"
      onCancel={onCancel}
      onConfirm={() => removeAdmin(adminToken)}
      confirmButtonId="remove_administrator_confirm_button"
      confirmButtonText={t(
        'organizationDetails:admins.deleteAdminDialog.confirmButtonText',
      )}
      cancelButtonText={t('common:no')}
      isConfirmButtonSubmitting={isLoadingRemoveAdmin}>
      <Typography color="textPrimary" variant="body2">
        {t('organizationDetails:admins.deleteAdminDialog.description', {
          email: adminEmail,
        })}
      </Typography>
    </Dialog>
  );
};

export default RemoveAdminDialog;
